import { ErrorMapper } from "@/core/shared/api/domain/serializers";
import { PortrayalResultErrors } from "@/core/portrayal/domain/portrayalErrors";

export const portrayalResultErrorMapper: ErrorMapper = {
  blurred_image_error: { reason: PortrayalResultErrors.BlurredImageError },
  document_classification_error: { reason: PortrayalResultErrors.DocumentClassificationError },
  spoofed_image_error: { reason: PortrayalResultErrors.SpoofedImageError },
  validas_error: { reason: PortrayalResultErrors.ValidasError },
};
